/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:8d9637f5-25c6-4a8f-87da-b0f804e16a0d",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_sjFIhHlvo",
    "aws_user_pools_web_client_id": "3vv4jmr05h3vg7b1utfjqa2k7h",
    "oauth": {
        "domain": "camptext5afd530f-5afd530f-dev.auth.us-west-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:3000/,https://campsitetext.com/",
        "redirectSignOut": "http://localhost:3000/,https://campsitetext.com/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_appsync_graphqlEndpoint": "https://675tzyoxwfbwvodnft7g75gay4.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-j6xvmu6ssbdhdc6icls2pnorsu",
    "aws_cloud_logic_custom": [
        {
            "name": "getSite",
            "endpoint": "https://swomtu6bnl.execute-api.us-west-2.amazonaws.com/dev",
            "region": "us-west-2"
        }
    ]
};


export default awsmobile;
